import { type Control, useFormState, useWatch } from 'react-hook-form';
import { Stack, Grid, Typography, Divider, Box } from '@mui/material';
import ViewStreamIcon from '@mui/icons-material/ViewStream';

import { type EditAuditFormBackgroundData } from '#apps/client-web/pages/audit-form-background/types';

import { isNil } from '#packages/data-collection/libs/lodash';

export type WallTypesDetailsProps = {
  control: Control<EditAuditFormBackgroundData>;
};

export const WallTypesDetails = ({ control }: WallTypesDetailsProps) => {
  const { errors } = useFormState({ control });

  const { envelope } = useWatch({ control });
  const wallTypes = envelope?.wallTypes;

  const attachmentCount = wallTypes?.attachments?.length ?? 0;

  const items = [
    {
      label: 'Structural framing',
      value: wallTypes?.structuralFraming,
      error: !!errors.envelope?.wallTypes?.structuralFraming,
    },
    {
      label: 'Cladding types',
      value: wallTypes?.claddingTypes,
      error: !!errors.envelope?.wallTypes?.claddingTypes,
    },
    {
      label: 'Attachments',
      value: attachmentCount > 0 ? String(attachmentCount) : undefined,
      error: false,
    },
  ];

  return (
    <Box sx={{ width: '100%' }}>
      <Stack spacing={1}>
        <Typography
          component="div"
          variant="body2"
          color="textSecondary"
          sx={{ mb: 0.5 }}>
          <Grid container alignItems="center">
            <ViewStreamIcon fontSize="inherit" />
            <span>&nbsp;Wall types</span>
          </Grid>
        </Typography>
        {items.map(({ label, value, error }) => (
          <Grid key={label} container justifyContent="space-between">
            <Typography component="span" variant="body2">
              {label}:
            </Typography>
            <Typography
              component="span"
              variant="body2"
              color={
                error ? 'error' : isNil(value) ? 'textDisabled' : 'textPrimary'
              }>
              {isNil(value) ? '—' : value}
            </Typography>
          </Grid>
        ))}
        <Divider />
      </Stack>
    </Box>
  );
};
